// src/components/DevStream/EventCardHeader.js
import React from "react";
import "./DevStream.css";
import { getSourceClass, formatTime } from "./utils/eventParsers";

/**
 * EventCardHeader - Header section of DevStream event card
 *
 * Features:
 * - Source badge (YP, MC, SYSTEM_ERROR)
 * - Event type display
 * - Timestamp display
 * - Copy button
 * - Expand/collapse toggle
 */
const EventCardHeader = ({
  source,
  eventType,
  timestamp,
  expanded,
  onToggle,
  onCopy,
}) => {
  return (
    <div className="event-card-header" onClick={onToggle}>
      <div className="event-card-left">
        <span className={`source-badge ${getSourceClass(source)}`}>
          {source}
        </span>
        <span className="event-type">{eventType}</span>
        <span className="event-time">{formatTime(timestamp)}</span>
      </div>

      <div className="event-card-right">
        <button
          className="copy-event-btn"
          onClick={onCopy}
          title="Copy Header and Body to Clipboard"
        >
          📋
        </button>
        <span className="expand-icon">{expanded ? "▼" : "▶"}</span>
      </div>
    </div>
  );
};

export default EventCardHeader;
